import { useCallback } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useSelector } from 'react-redux'
import { findIndex, values } from 'lodash'
import Step3SelectUserFunctionCategory from '@/pages/account/twc/_components/JoinOrganizationForTwcPage/Step3SelectUserFunctionCategory'

export const Route = createFileRoute('/app/account/twc/join/$orgType/$orgId')({
  component: RouteComponent,
})

function RouteComponent() {
  const orgTypes = useSelector((state: any) => state.app_meta.data.organizationTypes)

  const validateOrgTypeMachineName = useCallback(
    (otm: string) => {
      otm = otm.toLowerCase()
      let orgTypesArr = values(orgTypes)
      let idx = findIndex(orgTypesArr, ['machine_name', otm])
      return idx !== -1
    },
    [orgTypes],
  )

  return <Step3SelectUserFunctionCategory validateOrgTypeMachineNameFn={validateOrgTypeMachineName} />
}
